import React from "react";
import PromoCards from "./promoCards";

const TaglineV4 = () => (
    <section className="dark:bg-gray-900 pt-20">
        <h1 className="pt-6 text-3xl font-semibold text-center text-gray-800 dark:text-gray-200">
            Tailwind CSS v4 Cheat Sheet
        </h1>

        <p className="max-w-6xl px-4 mx-auto mt-4 text-base text-center text-gray-500 dark:text-gray-400 md:text-lg">
            All Tailwind CSS v4 utility classes with their CSS properties — including new 3D transforms, container queries, inset shadows, field sizing and more.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 max-w-3xl px-4 mx-auto mt-4">
            <span className="inline-flex items-center px-3 py-1 text-xs font-semibold text-orange-700 bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-300">
                🆕 3D Transforms
            </span>
            <span className="inline-flex items-center px-3 py-1 text-xs font-semibold text-blue-700 bg-blue-100 rounded-full dark:bg-blue-900/30 dark:text-blue-300">
                🆕 Container Queries
            </span>
            <span className="inline-flex items-center px-3 py-1 text-xs font-semibold text-purple-700 bg-purple-100 rounded-full dark:bg-purple-900/30 dark:text-purple-300">
                🆕 Inset Shadows
            </span>
            <span className="inline-flex items-center px-3 py-1 text-xs font-semibold text-green-700 bg-green-100 rounded-full dark:bg-green-900/30 dark:text-green-300">
                🆕 Field Sizing
            </span>
            <span className="inline-flex items-center px-3 py-1 text-xs font-semibold text-red-700 bg-red-100 rounded-full dark:bg-red-900/30 dark:text-red-300">
                ⚠️ Breaking Changes
            </span>
        </div>

        <PromoCards refPrefix="twc-cheatsheet-v4" />

        <p className="max-w-6xl px-4 mx-auto mt-4 text-base italic text-center text-gray-500 dark:text-gray-400 md:text-lg">
            "Never memorize something that you can look up." - Albert Einstein
        </p>
    </section>
);

export default TaglineV4;
